import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { MockupShowcase } from './MockupShowcase';
export function VSLSection3() {
  const videoRef = useRef<HTMLVideoElement>(null);
  return <section className="min-h-screen bg-navy flex flex-col items-center pt-10 pb-4 px-4 relative overflow-hidden" data-id="element-250">
      {/* Decorative background */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 opacity-20" data-id="element-251">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] rounded-full bg-sage blur-[100px]" data-id="element-252"></div>
        <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] rounded-full bg-terracotta blur-[100px]" data-id="element-253"></div>
      </div>

      <div className="w-full max-w-4xl mx-auto z-10 flex flex-col items-center" data-id="element-254">
        <h1 className="text-2xl md:text-4xl font-serif font-bold text-cream text-center mb-4 leading-tight text-balance" data-id="element-255">
          El método comprobado para que tu hijo deje las pantallas sin peleas
        </h1>

        <div className="w-full relative pt-[56.25%] rounded-2xl overflow-hidden shadow-2xl border-4 border-cream/10 bg-black" data-id="element-256">
          <video ref={videoRef} className="absolute top-0 left-0 w-full h-full object-contain" controls src="https://cdn.magicpatterns.com/uploads/5eRYtY4uQ96WBd1ZCFPvVV/vsl-1%20(1)%20(1).mp4" data-id="element-257" />
        </div>

        <div className="min-h-[4rem] mt-4 flex items-center justify-center w-full" data-id="element-258">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-259">
            <Link to="/" className="bg-terracotta hover:bg-terracotta-dark text-white font-bold py-4 px-8 rounded-full shadow-xl transition-all duration-300 flex items-center gap-3 text-xl cta-pulse no-underline" data-id="element-260">
              Sí, quiero ver la oferta
              <ArrowRight className="w-6 h-6 animate-pulse" data-id="element-261" />
            </Link>
          </motion.div>
        </div>
      </div>

      {/* Mockups below VSL */}
      <MockupShowcase data-id="element-262" />
    </section>;
}